import {
	convex,
	docker,
	expressjs,
	figma,
	map,
	mongodb,
	mysql,
	nextjs,
	nodejs,
	postgresql,
	reactjs,
	tailwind,
	threejs,
	typescript,
	vue,
} from "@/assets";

export type ExperienceHighlight = {
	title: string;
	body: string;
};

export type FocusTrack = {
	name: string;
	icon: string;
};

export const experienceHighlights: ExperienceHighlight[] = [
	{
		title: "Monorepo leadership",
		body: "Scaled CICCC's shared Next.js + Convex codebase, aligning marketing + admin apps with one design system.",
	},
	{
		title: "Workflow automation",
		body: "Built CornerDocs' admissions, quizzes, and PDF document engines for student success teams.",
	},
	{
		title: "Immersive storytelling",
		body: "Designed interactive mapping experiences (Shin Sakura) and bespoke UI systems for partner studios.",
	},
];

export const focusTracks: FocusTrack[] = [
	{ name: "React", icon: reactjs },
	{ name: "Next.js", icon: nextjs },
	{ name: "TypeScript", icon: typescript },
	{ name: "Tailwind", icon: tailwind },
	{ name: "Convex", icon: convex },
	{ name: "Vue", icon: vue },
	{ name: "3D", icon: threejs },
	{ name: "Design systems", icon: figma },
	{ name: "Node.js", icon: nodejs },
	{ name: "Express", icon: expressjs },
	{ name: "MySQL", icon: mysql },
	{ name: "PostgreSQL", icon: postgresql },
	{ name: "MongoDB", icon: mongodb },
	{ name: "Interactive maps", icon: map },
	{ name: "DX & CI/CD", icon: docker },
];

